import { StudyContextData, SubmissionContextData } from "@/context/AppContext";
import { useStudyView } from "@/context/ViewContexts";

import { InitView } from "@/views/study/InitView";
import { SubmissionView } from "@/views/study/SubmissionView";
import { ReportView } from "@/views/study/ReportView";
import { ClosedView } from "@/views/study/ClosedView";
import { SuccessView } from "@/views/study/SuccessView";

interface StudyViewProps {
  studyContext: StudyContextData;
  submissionContext: SubmissionContextData;
}

export default function StudyView({ studyContext, submissionContext }: StudyViewProps) {
  const { state: studyViewState } = useStudyView();

  switch (studyViewState.view) {
    case "init":
      return <InitView studyContext={studyContext} />;
    case "submission":
      return <SubmissionView studyContext={studyContext} submissionContext={submissionContext} />;
    case "success":
      return <SuccessView studyContext={studyContext} submissionContext={submissionContext} />;
    case "report":
      return <ReportView studyContext={studyContext} submissionContext={submissionContext} />;
    case "closed":
      return <ClosedView />;
  }
}
